/**
 * Videos page vocabulary (`/videos`, `/videos/line/:id`): filters, the
 * delivery cards, download and preview states. Assembled into `WorkspaceCopy`
 * by `../copy.ts`.
 */

export const videosCopyEn = {
  videos: {
    title: 'Videos',
    allWorkspaces: 'All workspaces',
    desc: 'Every video across your workspaces. Filter by workspace or Production Line to narrow down.',
    scopedDesc: 'Videos from this Production Line only.',
    showAll: 'Show all workspaces',
    filters: 'Video filters',
    workspace: 'Workspace',
    line: 'Production Line',
    allLines: 'All Production Lines',
    status: 'Status',
    anyStatus: 'Any status',
    date: 'Date',
    anyDate: 'Any date',
    today: 'Today',
    last7: 'Last 7 days',
    last30: 'Last 30 days',
    language: 'Language',
    anyLanguage: 'Any language',
    platform: 'Format or platform',
    anyPlatform: 'Any platform',
    aspect: 'Aspect ratio',
    anyAspect: 'Any aspect ratio',
    clear: 'Clear filters',
    noVideos: 'No videos yet',
    noVideosBody: 'Videos appear here as soon as a Production Line finishes one.',
    noMatch: 'No videos match these filters',
    noMatchBody: 'Try removing a filter.',
    open: (title: string) => `Open ${title}`,
    video: 'Video',
    closeDetails: 'Close video details',
    generationHistory: 'Generation history',
    openLine: 'Open Production Line',
    needsReview: 'Needs your review.',
    needsReviewBody:
      'Check the on-screen text before downloading — a programme name may be spelled differently from your site.',
    couldNotCreate: 'Couldn’t create this video.',
    unavailable: 'Your videos are temporarily unavailable.',
  },
};

export const videosCopyAr: typeof videosCopyEn = {
  videos: {
    title: 'الفيديوهات',
    allWorkspaces: 'كل مساحات العمل',
    desc: 'كل فيديوهاتك في كل مساحات عملك. صفِّ حسب مساحة العمل أو خط الإنتاج عشان تضيّق النتائج.',
    scopedDesc: 'فيديوهات خط الإنتاج هذا بس.',
    showAll: 'ورّي كل مساحات العمل',
    filters: 'تصفية الفيديوهات',
    workspace: 'مساحة العمل',
    line: 'خط الإنتاج',
    allLines: 'كل خطوط الإنتاج',
    status: 'الحالة',
    anyStatus: 'أي حالة',
    date: 'التاريخ',
    anyDate: 'أي تاريخ',
    today: 'اليوم',
    last7: 'آخر 7 أيام',
    last30: 'آخر 30 يومًا',
    language: 'اللغة',
    anyLanguage: 'أي لغة',
    platform: 'الصيغة أو المنصة',
    anyPlatform: 'أي منصة',
    aspect: 'نسبة الأبعاد',
    anyAspect: 'أي نسبة أبعاد',
    clear: 'امسح التصفية',
    noVideos: 'ما فيه فيديوهات لين الحين',
    noVideosBody: 'الفيديوهات تظهر هنا أول ما يخلص خط إنتاج واحد منها.',
    noMatch: 'ما فيه فيديوهات تطابق هذي التصفية',
    noMatchBody: 'جرّب تشيل أحد عوامل التصفية.',
    open: (title: string) => `فتح ${title}`,
    video: 'فيديو',
    closeDetails: 'إغلاق تفاصيل الفيديو',
    generationHistory: 'سجل الإنشاء',
    openLine: 'افتح خط الإنتاج',
    needsReview: 'يحتاج مراجعتك.',
    needsReviewBody:
      'راجع النص على الشاشة قبل ما تنزّله — يمكن اسم برنامج يكون مكتوب بشكل مختلف عن موقعك.',
    couldNotCreate: 'ما قدرنا نسوي هذا الفيديو.',
    unavailable: 'فيديوهاتك مو متاحة مؤقتًا.',
  },
};
